/**@jsxImportSource @emotion/react/ */
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LoginLogoutButton from "../login-logout/LoginLogoutButton";


const linkStyle = {
  textDecoration: "none",
  color: "black",
  marginRight: '1rem',
  marginLeft:'1rem'
};

type Claims = {
  roles: string[];
};

const NavBar: FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const [canViewAudit, setCanViewAudit] = useState<boolean>(false);
  const [canActivateCompanies, setCanActivateCompanies] = useState<boolean>(false);
  const { instance } = useMsal();

  useEffect(() => {
    if (isAuthenticated) {
      const claims: Claims | undefined = instance.getActiveAccount()
        ?.idTokenClaims as Claims;

      if (claims.roles !== undefined) {
        const allowedToViewAudit = claims.roles.includes("Audit.View");
        const allowedToActivate = claims.roles.includes("CompanyManager");

        setCanViewAudit(allowedToViewAudit);
        setCanActivateCompanies(allowedToActivate);
      }
    }
  }, [isAuthenticated, instance]);

  return (
    <nav className="navbar navbar-expand-lg navbar-light p-0">
      <div className="container-fluid bg-light">
   
          <Link  to="/" >
            <img
              src="Banner.png"
              alt="EverLogic banner"
              style={{ width: "200px", height: "50px"  }}
            />
          </Link>
       
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "#535353 ",
              fontWeight: 750,
              fontSize: "1.8rem",
              width: '15%',
              paddingTop:'4px'
            }}
          >
            License Utility
          </Link>
              
        <div
          style={{        
            width: "54%",
            paddingTop: '10px',
            fontSize:'1.3rem',
          }}
        >
          <Link  to="/kenect" style={linkStyle}>
            Kenect
          </Link>
          {canViewAudit && (
            <Link to="/audit" style={linkStyle} >
              Audit
            </Link>
          )}
          {canActivateCompanies && (
            <Link to="/inactive" style={linkStyle} >
              Reactivate
            </Link>
          )}
        </div>

        <div className="nav-item">
          <LoginLogoutButton />
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
